import { CaPageHeader, usePath } from "@/company-admin/shared";

export default function Permissions() {
    const { data: roles, loading } = usePath("/company-admin/roles");
    const { data: perms } = usePath("/company-admin/permissions");

    return (
        <div data-testid="ca-permissions-page">
            <CaPageHeader
                title="Permissions Matrix"
                subtitle="A read-only view of what each role can do in your company. Modify per-role in the Roles page."
            />

            {loading ? (
                <div className="glass rounded-3xl p-6 h-[500px] animate-pulse" />
            ) : (
                <div className="glass rounded-3xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm">
                            <thead>
                                <tr>
                                    <th className="sticky left-0 z-10 bg-white/90 backdrop-blur-md text-left px-5 py-3 text-[10px] font-semibold tracking-[0.16em] uppercase text-neutral-500 border-b border-black/[0.06]">
                                        Permission
                                    </th>
                                    {(roles || []).map((r) => (
                                        <th key={r.id} className="text-center px-3 py-3 text-[10px] font-semibold tracking-[0.16em] uppercase text-neutral-500 border-b border-black/[0.06] whitespace-nowrap">
                                            {r.name}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {(perms || []).map((p) => (
                                    <tr key={p.key} className="border-t border-black/[0.05]">
                                        <td className="sticky left-0 z-10 bg-white/95 backdrop-blur-md px-5 py-3 text-black font-medium">
                                            {p.label}
                                        </td>
                                        {(roles || []).map((r) => {
                                            const has = (r.permissions_effective || []).includes(p.key);
                                            return (
                                                <td key={r.id} className="text-center px-3 py-3">
                                                    {has ? (
                                                        <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-violet-500 text-white">
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                                <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </span>
                                                    ) : (
                                                        <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-neutral-100 text-neutral-300">
                                                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                                            </svg>
                                                        </span>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
}
